import type {JsonApiResponse} from "~/types/JsonApiResponse";
import type {MyFavoritesData} from "~/types/MyFavoritesData";
import type {GenericStatusData} from "~/types/GenericStatusData";

export const useMyFavorites = () => {
    const getMyFavorites = () => {
        return useAsyncData<JsonApiResponse<MyFavoritesData>>("my-favorites", () => $api("/api/my-favorites"));
    };

    const toggleProjectFavorite = async (projectUuid: string) => {
        return await $api<{ data: GenericStatusData }>(`/api/project/${projectUuid}/toggle-favorite`, {
            method: "POST",
        });
    };

    const toggleChapterFavorite = async (chapterUuid: string) => {
        return await $api<{ data: GenericStatusData }>(`/api/chapter/${chapterUuid}/toggle-favorite`, {
            method: "POST",
        });
    };

    const handleProjectFavorite = (initialStatus: boolean, refreshData?: () => void) => {
        const isFavorite = ref(initialStatus);
        const isPending = ref(false);

        const toggleFavorite = async (projectUuid: string) => {
            try {
                isPending.value = true;
                const response = await toggleProjectFavorite(projectUuid);
                if (refreshData) {
                    refreshData();
                } else {
                    isFavorite.value = response.data.status;
                }
            } catch (e) {
                console.error("Erreur lors du changement de favoris", e);
            } finally {
                isPending.value = false;
            }
        };

        return {
            isFavorite,
            isPending,
            toggleFavorite,
        };
    };

    const handleChapterFavorite = (initialStatus: boolean, refreshData?: () => void) => {
        const isFavorite = ref(initialStatus);
        const isPending = ref(false);

        const toggleFavorite = async (chapterUuid: string) => {
            try {
                isPending.value = true;
                const response = await toggleChapterFavorite(chapterUuid);
                if (refreshData) {
                    refreshData();
                } else {
                    isFavorite.value = response.data.status;
                }
            } catch (e) {
                console.error("Erreur lors du changement de favoris", e);
            } finally {
                isPending.value = false;
            }
        };

        return {
            isFavorite,
            isPending,
            toggleFavorite,
        };
    };

    return {
        getMyFavorites,
        toggleProjectFavorite,
        toggleChapterFavorite,
        handleProjectFavorite,
        handleChapterFavorite,
    };
};
